import "../Base";
import "../../OL3";
import { InvalidArgumentError } from '../../../../errors';

/** @namespace GIS.Map.Control.OL3 */
NS("GIS.Map.Control.OL3");

/**
 * @class
 * @extends GIS.Map.Control.Base
 */
GIS.Map.Control.OL3.Base = Class(GIS.Map.Control.Base, /** @lends GIS.Map.Control.OL3.Base.prototype */ {
    /**
     * @type {GIS.Map.OL3}
     * @protected
     */
    map_: null,
    /** @inheritDoc */
    initialize(map) {
        this.map_ = map.getMap();
        assert(this.map_.Is(GIS.Map.OL3), "accepts only GIS.Map.OL3 map", InvalidArgumentError);

        this.ParentCall();
    },
    /**
     * @returns {GIS.Map.OL3}
     */
    getMapObject() {
        return this.map_;
    }
});
